import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '@shopify/polaris';
import { CalendarTimeIcon } from '@shopify/polaris-icons';

const ProjectsSidebar = () => {
  const location = useLocation();

  const navigationItems = [
    {
      label: 'Project Management',
      url: '/projects/jobs',
      icon: CalendarTimeIcon as any,
      matches: true,
      subNavigationItems: [
        {
          url: '/projects/jobs',
          disabled: false,
          label: 'Jobs',
        },
        {
          url: '/projects/schedule',
          disabled: false,
          label: 'Project Schedules',
        },
        {
          url: '/projects/crew-calendar',
          disabled: false,
          label: 'Crew Schedules',
        },
        {
          url: '/projects/calendar',
          disabled: false,
          label: 'Calendar',
        },
      ],
    },
  ];

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default ProjectsSidebar;
